import { S3Client } from '@aws-sdk/client-s3';

const awsKey = process.env.REACT_APP_AWS_KEY;
const awsSecret = process.env.REACT_APP_AWS_SECRET;
const awsRegion = process.env.REACT_APP_AWS_REGION;

if (!awsKey || !awsSecret || !awsRegion) {
  throw new Error('Missing required AWS environment variables: REACT_APP_AWS_KEY, REACT_APP_AWS_SECRET, REACT_APP_AWS_REGION');
}

const s3 = new S3Client({
  credentials: {
    accessKeyId: awsKey,
    secretAccessKey: awsSecret,
  },
  region: awsRegion,
});

export default s3;
